import creditCardUtils from 'creditcardutils';

export const getCardType = value => {
    const cardType = creditCardUtils.parseCardType(value);
    switch (cardType) {
        case 'visa':
        case 'visaelectron':
            return 'visa';
        default:
            return cardType;
    }
};
